import React from 'react';
import './LandingPage.css';

function LandingPage({ onGetStarted }) {
  return (
    <div className="landing">
      <nav className="landing-nav">
        <div className="logo">🎯 BetPilot</div>
        <button className="nav-login" onClick={onGetStarted}>Login</button>
      </nav>

      <main className="landing-hero">
        <h1>AI-Powered Sports Betting Intelligence</h1>
        <p className="hero-sub">Get smarter picks, real-time analysis, and data-driven insights to elevate your betting game.</p>
        
        <div className="trial-cta">
          <button className="cta-primary" onClick={onGetStarted}>
            Start Free Trial
          </button>
          <p className="trial-info">30 days free • No credit card required</p>
        </div>
        
        <p className="disclaimer">21+ | Gamble responsibly | Not financial advice</p>
      </main>

      <section className="features">
        <div className="feature">
          <span className="feature-icon">🤖</span>
          <h3>AI Analysis</h3>
          <p>Advanced models analyze thousands of data points for every pick</p>
        </div>
        <div className="feature">
          <span className="feature-icon">📊</span>
          <h3>Real-Time Odds</h3>
          <p>Track line movements and find value across sportsbooks</p>
        </div>
        <div className="feature">
          <span className="feature-icon">💬</span>
          <h3>Ask Anything</h3>
          <p>Chat with our AI about any game, player, or betting strategy</p>
        </div>
      </section>

      <footer className="landing-footer">
        <p>© 2024 BetPilot. All rights reserved.</p>
        <div className="social-links">
          <a href="https://twitter.com/BetPilotHQ" target="_blank" rel="noopener noreferrer">Twitter</a>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
